function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint-disable max-classes-per-file, class-methods-use-this */
import prettierBytes from '@transloadit/prettier-bytes';
import match from 'mime-match';
var defaultOptions = {
  maxFileSize: null,
  minFileSize: null,
  maxTotalFileSize: null,
  maxNumberOfFiles: null,
  minNumberOfFiles: null,
  allowedFileTypes: null,
  requiredMetaFields: []
};

var RestrictionError = /*#__PURE__*/function (_Error) {
  _inherits(RestrictionError, _Error);

  var _super = _createSuper(RestrictionError);

  function RestrictionError() {
    var _this;

    _classCallCheck(this, RestrictionError);

    _this = _super.apply(this, arguments);
    _this.isRestriction = true;
    return _this;
  }

  return _createClass(RestrictionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var Restricter = /*#__PURE__*/function () {
  function Restricter(getOpts, i18n) {
    _classCallCheck(this, Restricter);

    this.i18n = i18n;

    this.getOpts = function () {
      var opts = getOpts();

      if (opts.restrictions.allowedFileTypes != null && !Array.isArray(opts.restrictions.allowedFileTypes)) {
        throw new TypeError('`restrictions.allowedFileTypes` must be an array');
      }

      return opts;
    };
  }

  _createClass(Restricter, [{
    key: "validate",
    value: function validate(file, files) {
      var _this$getOpts$restric = this.getOpts().restrictions,
          maxFileSize = _this$getOpts$restric.maxFileSize,
          minFileSize = _this$getOpts$restric.minFileSize,
          maxTotalFileSize = _this$getOpts$restric.maxTotalFileSize,
          maxNumberOfFiles = _this$getOpts$restric.maxNumberOfFiles,
          allowedFileTypes = _this$getOpts$restric.allowedFileTypes;

      if (maxNumberOfFiles) {
        var nonGhostFiles = files.filter(function (f) {
          return !f.isGhost;
        });

        if (nonGhostFiles.length + 1 > maxNumberOfFiles) {
          throw new RestrictionError("".concat(this.i18n('youCanOnlyUploadX', {
            smart_count: maxNumberOfFiles
          })));
        }
      }

      if (allowedFileTypes) {
        var isCorrectFileType = allowedFileTypes.some(function (type) {
          // check if this is a mime-type
          if (type.includes('/')) {
            if (!file.type) return false;
            return match(file.type.replace(/;.*?$/, ''), type);
          } // otherwise this is likely an extension


          if (type[0] === '.' && file.extension) {
            return file.extension.toLowerCase() === type.slice(1).toLowerCase();
          }

          return false;
        });

        if (!isCorrectFileType) {
          var allowedFileTypesString = allowedFileTypes.join(', ');
          throw new RestrictionError(this.i18n('youCanOnlyUploadFileTypes', {
            types: allowedFileTypesString
          }));
        }
      } // We can't check maxTotalFileSize if the size is unknown.


      if (maxTotalFileSize && file.size != null) {
        var totalFilesSize = files.reduce(function (total, f) {
          return total + f.size;
        }, file.size);

        if (totalFilesSize > maxTotalFileSize) {
          throw new RestrictionError(this.i18n('exceedsSize', {
            size: prettierBytes(maxTotalFileSize),
            file: file.name
          }));
        }
      } // We can't check maxFileSize if the size is unknown.


      if (maxFileSize && file.size != null && file.size > maxFileSize) {
        throw new RestrictionError(this.i18n('exceedsSize', {
          size: prettierBytes(maxFileSize),
          file: file.name
        }));
      } // We can't check minFileSize if the size is unknown.


      if (minFileSize && file.size != null && file.size < minFileSize) {
        throw new RestrictionError(this.i18n('inferiorSize', {
          size: prettierBytes(minFileSize)
        }));
      }
    }
  }, {
    key: "validateMinNumberOfFiles",
    value: function validateMinNumberOfFiles(files) {
      var minNumberOfFiles = this.getOpts().restrictions.minNumberOfFiles;

      if (Object.keys(files).length < minNumberOfFiles) {
        throw new RestrictionError(this.i18n('youHaveToAtLeastSelectX', {
          smart_count: minNumberOfFiles
        }));
      }
    }
  }, {
    key: "getMissingRequiredMetaFields",
    value: function getMissingRequiredMetaFields(file) {
      var error = new RestrictionError(this.i18n('missingRequiredMetaFieldOnFile', {
        fileName: file.name
      }));
      var requiredMetaFields = this.getOpts().restrictions.requiredMetaFields;
      var missingFields = [];

      var _iterator = _createForOfIteratorHelper(requiredMetaFields),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var field = _step.value;

          if (!Object.hasOwn(file.meta, field) || file.meta[field] === '') {
            missingFields.push(field);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        missingFields: missingFields,
        error: error
      };
    }
  }]);

  return Restricter;
}();

export { Restricter, defaultOptions, RestrictionError };